import {
  FormAnswer,
  FormTemplateQuestion,
  FormTemplateQuestionFieldsKindEnum,
} from 'graphql-common';
import mergeTaskQuestionsWithAnswers from './mergeTaskQuestionsWithAnswers';
import { TaskCompletionDetailsTableRow } from '../types';

export default function buildTaskCompletionDetailsRows(
  questions: FormTemplateQuestion[] | null | undefined,
  answers: FormAnswer[] | null | undefined,
): TaskCompletionDetailsTableRow[] {
  const mergedQuestions = mergeTaskQuestionsWithAnswers(questions, answers, [
    FormTemplateQuestionFieldsKindEnum.Section,
  ]);

  return mergedQuestions.flatMap((question) =>
    question.fields.map((field) => ({
      ...field,
      questionName: question.name,
      questionPosition: question.position,
    })),
  );
}
